import React from 'react'

export const MultipleQuestionEmp = ({id,text_value,correct,order,questionClick}) => {
    return (
        <div className="btn-question" onClick={questionClick} id={id} key={id} order={order}>{text_value} <br/></div>
    )
}
